import styled from 'styled-components';

type Props = {
  value?: string;
  options: [string, string][];
  onChangeFn: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  label: string;
  className?: string;
};
export function SortControl({
  options,
  value,
  label,
  onChangeFn,
}: Props): React.JSX.Element {
  const renderOptions = options.map((option) => (
    <option key={option[0]} value={option[0]} className="text-slate12">
      {option[1]}
    </option>
  ));

  return (
    <Controls>
      <Label>
        {label}:&nbsp;
        <Dropdown
          //   value={sortBy.label}
          name="sortBy"
          value={value}
          //   onChange={(e) => setSortBy(sortOptions[e.target.value])}
          onChange={onChangeFn}
        >
          {renderOptions}
        </Dropdown>
      </Label>
    </Controls>
  );
}

const Controls = styled.div`
  display: flex;
  align-items: center;
`;
const Label = styled.label`
  display: block;
  font-weight: 700;
  text-transform: uppercase;
`;
const Dropdown = styled.select`
  font-weight: inherit;
  color: inherit;
  border: 0;
  outline: none;
  background-color: transparent;
`;
